import React from "react";
import { Link } from "react-router-dom";
import EmptyState from "../components/ui/EmptyState";
import { paths } from "../routes/paths";
import "./NotFound.css";

// Fora do shell e fora da guarda: acoplar o 404 a ProtectedRoute faria um deep
// link errado virar redirect para o login, mentindo sobre a causa.
function NotFound() {
  return (
    <div className="notfound">
      <EmptyState
        icon="folder"
        titleTag="h1"
        title="Página não encontrada"
        help="O endereço acessado não existe ou foi movido."
        action={
          <Link className="btn btn-primary" to={paths.projects}>
            Ir para Projetos
          </Link>
        }
      />
    </div>
  );
}

export default NotFound;
